var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/components/x-buildify-color-picker.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { injectAttributesOf } from "@adornis/chemistry/directives/inject-attributes.js";
import "@adornis/chemistry/elements/components/x-card.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-formfield-wrapper.js";
import "@adornis/chemistry/elements/components/x-grid.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import "@adornis/fonts/fonts.js";
import "@adornis/forms/x-input.js";
import "@adornis/popover/x-dropdown.js";
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { createRef, ref } from "lit/directives/ref.js";
import { repeat } from "lit/directives/repeat.js";
import { XBuildifyGlobalSettingsFormField } from "./x-buildify-global-settings-formfield.js";
var XBuildifyColorPicker = class extends XBuildifyGlobalSettingsFormField {
  constructor() {
    super(...arguments);
    this._colorPickerDropdownEl = createRef();
  }
  render() {
    if (!this._consumedGlobalSettingsClassName.value)
      return this._freeForm();
    return xComponents(html`
      <x-dropdown ${ref(this._colorPickerDropdownEl)}>
        <x-formfield-wrapper
          show-label
          ${injectAttributesOf(this)}
          @click=${(e) => {
      e.stopPropagation();
      e.preventDefault();
      if (!this.disabled)
        this._colorPickerDropdownEl.value?.toggle();
    }}
          @cleared=${() => {
      this.value.next(null);
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: this.value.value } }));
      this.requestUpdate();
    }}
        >
          <x-flex ${css({ height: "20px", background: this.value.value ?? "" })}></x-flex>
        </x-formfield-wrapper>
        <x-buildify-color-picker-dropdown-content
          slot="dropdown-content"
          .value=${this.value.value}
          @selected=${(e) => {
      this.value.next(e.detail.value);
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: this.value.value } }));
      void this._colorPickerDropdownEl.value?.close();
      this.requestUpdate();
    }}
          .selectableColors=${this._globalSettings.value?.colors}
        ></x-buildify-color-picker-dropdown-content>
      </x-dropdown>
    `);
  }
  _freeForm() {
    return html`
      <x-input
        ${injectAttributesOf(this)}
        .value=${this.value.value}
        @value-picked=${(e) => {
      this.value.next(e.detail.value);
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: this.value.value } }));
    }}
        error=${ifDefined(this.error)}
        type="color"
      >
      </x-input>
    `;
  }
};
XBuildifyColorPicker = __decorateClass([
  customElement("x-buildify-color-picker")
], XBuildifyColorPicker);
var XBuildifyColorPickerDropdownContent = class extends ChemistryLitElement {
  render() {
    return html`
      <x-basic-card padding="md" space="md" crossaxis-center>
        <x-grid space="sm" auto-fit-columns="50px" ${css({ width: "100%" })}>
          ${repeat(
      this.selectableColors ?? [],
      (colorCode) => html`
                <div
                  @click=${() => this.dispatchEvent(new CustomEvent("selected", { detail: { value: colorCode } }))}
                  ${css({
        // height: '50px',
        // width: '50px',
        aspectRatio: "1 / 1",
        background: colorCode,
        cursor: "pointer",
        outline: this.value === colorCode ? "2px solid black" : ""
      })}
                ></div>
              `
    )}
        </x-grid>
        <x-text tone="subtle">
          Weitere Farben können über die globalen Einstellungen zur Verfügung gestellt werden.
        </x-text>
      </x-basic-card>
    `;
  }
};
__decorateClass([
  property()
], XBuildifyColorPickerDropdownContent.prototype, "value", 2);
__decorateClass([
  property({ attribute: false })
], XBuildifyColorPickerDropdownContent.prototype, "selectableColors", 2);
XBuildifyColorPickerDropdownContent = __decorateClass([
  customElement("x-buildify-color-picker-dropdown-content")
], XBuildifyColorPickerDropdownContent);
export {
  XBuildifyColorPicker,
  XBuildifyColorPickerDropdownContent
};
